import { conversionSpecValue, conversionTitle } from '@entities/Product/module/helper/conversionValue/conversionValue';
import { FC } from 'react';
import { conversionValue } from '../../../../module/helper/conversionValue';
import { isModal } from '../../../../module/helper/isModal';
import { ProductSpecCode, SeasonEnum, TornEnum } from '../../../../module/types/productSchema';
import { ProductSpecInfoModal } from '../../Modals/ProductSpecInfoModal';
import { ProductSpecTypeProps } from './TypeProps';

import classNames from 'classnames';
import IconSpikes from './icons/spikes.svg';
import IconSummer from './icons/summer.svg';
import IconWinter from './icons/winter.svg';

import styles from './ProductSpec.module.scss';

export const ProductSpec: FC<ProductSpecTypeProps> = ({ className, value, code, part, isShort }) => {
  return (
    <div
      itemScope
      itemProp="additionalProperty"
      itemType="https://schema.org/PropertyValue"
      className={classNames(styles.WrapperProductSpec, className)}
    >
      <div itemProp="name" className={styles.ProductSpecsTitle}>
        {conversionTitle(code, isShort)}
      </div>
      <div className={styles.Dotted}></div>
      <div itemProp="value" className={styles.ProductSpecsValue}>
        {code === ProductSpecCode.Season && (
          <>
            {conversionValue(code, value)}
            {parseInt(value as string) === SeasonEnum.Summer ? (
              <IconSummer className={styles.Season} />
            ) : (
              <IconWinter className={styles.Season} />
            )}
          </>
        )}
        {code === ProductSpecCode.Spikes && (
          <>
            {conversionValue(code, value)}
            {Number(value) === TornEnum.Torn && <IconSpikes className={styles.Season} />}
          </>
        )}
        {code !== ProductSpecCode.Season && code !== ProductSpecCode.Spikes && conversionSpecValue(code, value)}
        {isModal(part, code) && <ProductSpecInfoModal type={code} className={styles.Info} />}
      </div>
    </div>
  );
};
